import TimerComponent from './TimerComponent';

export default TimerComponent;
